// import StaryDream from './StaryDream';
// import { WhosBirthdayTomorrowInputsSeason } from './WhosBirthdayTomorrow';
import type { ICanvasInputItem } from '@shared/common/data/inputs';
import {
  bookInputValidatorWhen,
  INPUT_NAME_RESERVED_CANVAS2,
  bookInputsToNameValueMap,
  ESelectInputType,
  getCanvasInputData,
  getRadioColorInputData,
  getRadioColorInputOptionData,
  getRadioCoverInputData,
  getRadioCoverInputOptionData,
  getRadioInputData,
  getRadioInputOptionData,
  getSelectInputData,
  getTextInputData,
  INPUT_NAME_RESERVED_CANVAS1,
  bookInputShowWhen,
  getCheckboxInputData,
  getDateInputData,
  getSelectInputOptionData,
} from '@shared/common/data/inputs';
import type {
  TClothColor,
  THairColor,
  THairStyle,
  TSkinColor,
  TParents,
} from '@shared/common/product';
import {
  INPUT_NAME_P1_HAIR_COLOR,
  INPUT_NAME_P1_SKIN_COLOR,
  INPUT_NAME_P2_HAIR_COLOR,
  INPUT_NAME_P2_SKIN_COLOR,
  INPUT_VALUE_COVER_TYPE_SOFT,
  INPUT_VALUE_ENGLISH,
  INPUT_VALUE_PARENTS_MOM_AND_DAD,
  INPUT_NAME_SEASON,
  INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
  INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
  INPUT_NAME_CLOTH_COLOR,
  INPUT_NAME_COVER_IMAGE,
  INPUT_NAME_FREKLES,
  INPUT_NAME_HAIR_COLOR,
  INPUT_NAME_KIDS_BIRTHDAY,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_PARENTS,
  INPUT_NAME_SKIN_COLOR,
  INPUT_VALUE_CLOTH_COLOR_BLUE,
  INPUT_VALUE_CLOTH_COLOR_GREEN,
  INPUT_VALUE_CLOTH_COLOR_RED,
  INPUT_VALUE_CLOTH_COLOR_YELLOW,
  INPUT_VALUE_HAIR_COLOR_BLACK,
  INPUT_VALUE_HAIR_COLOR_BLONDE,
  INPUT_VALUE_HAIR_COLOR_BROWN,
  INPUT_VALUE_HAIR_COLOR_RED,
  INPUT_VALUE_HAIR_STYLE_CURL,
  INPUT_VALUE_HAIR_STYLE_STRAIGHT,
  INPUT_VALUE_JAPANESE,
  INPUT_VALUE_PARENTS_DAD,
  INPUT_VALUE_PARENTS_DAD_AND_DAD,
  INPUT_VALUE_PARENTS_MOM,
  INPUT_VALUE_PARENTS_MOM_AND_MOM,
  INPUT_VALUE_SKIN_COLOR_BLACK,
  INPUT_VALUE_SKIN_COLOR_BROWN,
  INPUT_VALUE_SKIN_COLOR_NUTMEG,
  INPUT_VALUE_SKIN_COLOR_WHITE,
  INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
  INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
  BOOK_ALIAS_WELCOME_TO_THE_WOLD,
  INPUT_NAME_HAIR_STYLE,
  INPUT_NAME_LANGUAGE,
  INPUT_VALUE_COVER_TYPE_HARD,
} from '@shared/common/product';
import {
  getBookNameEnValidatorList,
  GET_BOOK_NAME_ERROR_EN,
  GET_BOOK_NAME_ERROR,
  getNameValidatorList,
} from '@shared/jp/data/inputs';
import type { TLanguage } from '@shared/jp/product';
import {
  languageArr,
  BOOK_PRICE_WELCOME_TO_THE_WOLD,
  BOOK_PRICE_WELCOME_TO_THE_WOLD_HARD_COVER,
} from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';
import { getPriceData } from '@shared/jp/data/products';
import {
  EBannerTextColor,
  EDescriptionTextItemType,
  PURPOSE_ADVENTURE,
  PURPOSE_BIRTH_GIFT,
} from '@shared/common/data/products';
import { getCoverHard, getCoverSoft } from './_utils';

/**
 * * validatorWhen and showWhen are set inside IBook['inputs']
 * * by mutation funtions `bookInputValidatorWhen` and `bookInputShowWhenCheck`
 * * to make it possible to assign inputs between each other
 */

const WelcomeToTheWorldInputsKidsNameValidator = getNameValidatorList(8);
const WelcomeToTheWorldInputsKidsNameValidatorEn =
  getBookNameEnValidatorList(12);

export const WelcomeToTheWorldInputsKidsName = getTextInputData({
  label: 'Kid’s name',
  // placeholder: 'ひらがな８文字まで',
  get placeholder() {
    // @ts-ignore
    return this.validator === WelcomeToTheWorldInputsKidsNameValidatorEn
      ? ('Up to 12 characters EN' as const)
      : ('Up to 8 characters' as const);
  },
  // value: '',
  name: INPUT_NAME_KIDS_NAME,
  // will be added in inputs array
  // validator: getBookNameValidatorList(8),
  get error() {
    // @ts-ignore
    return this.validator === WelcomeToTheWorldInputsKidsNameValidatorEn
      ? GET_BOOK_NAME_ERROR_EN(12)
      : GET_BOOK_NAME_ERROR(8);
  },
} as const);

export const WelcomeToTheWorldInputsKidsBirthday = getDateInputData({
  label: 'Kid’s birthday',
  placeholder: 'yyyy/mm/dd',
  // value: new Date(),
  max: new Date(),
  name: INPUT_NAME_KIDS_BIRTHDAY,
} as const);

export const WelcomeToTheWorldInputsParents = getSelectInputData({
  selectType: ESelectInputType.imageText,
  label: 'Parents',
  placeholder: 'Please choose',
  options: [
    getSelectInputOptionData({
      label: 'Mom and Dad',
      imgSrc: 'assets/images/parents/mom-dad.png',
      value: INPUT_VALUE_PARENTS_MOM_AND_DAD,
    }),
    getSelectInputOptionData({
      label: 'Mom and Mom',
      imgSrc: 'assets/images/parents/mom-mom.png',
      value: INPUT_VALUE_PARENTS_MOM_AND_MOM,
    }),
    getSelectInputOptionData({
      label: 'Dad and Dad',
      imgSrc: 'assets/images/parents/dad-dad.png',
      value: INPUT_VALUE_PARENTS_DAD_AND_DAD,
    }),
    getSelectInputOptionData({
      label: 'Mom',
      imgSrc: 'assets/images/parents/mom.png',
      value: INPUT_VALUE_PARENTS_MOM,
    }),
    getSelectInputOptionData({
      label: 'Dad',
      imgSrc: 'assets/images/parents/dad.png',
      value: INPUT_VALUE_PARENTS_DAD,
    }),
  ],
  // value: '',
  name: INPUT_NAME_PARENTS,
});

const WelcomeToTheWorldInputsSkinColorOptions = [
  getRadioColorInputOptionData({
    color: '#FFEAD6',
    value: INPUT_VALUE_SKIN_COLOR_WHITE,
  }),
  getRadioColorInputOptionData({
    color: '#FAD5A2',
    value: INPUT_VALUE_SKIN_COLOR_NUTMEG,
  }),
  getRadioColorInputOptionData({
    color: '#CF9970',
    value: INPUT_VALUE_SKIN_COLOR_BROWN,
  }),
  getRadioColorInputOptionData({
    color: '#B28262',
    value: INPUT_VALUE_SKIN_COLOR_BLACK,
  }),
];

export const WelcomeToTheWorldInputsSkinColor = getRadioColorInputData({
  label: 'Skin color',
  options: WelcomeToTheWorldInputsSkinColorOptions,
  value: INPUT_VALUE_SKIN_COLOR_WHITE,
  name: INPUT_NAME_SKIN_COLOR,
});

export const WelcomeToTheWorldInputsFrekles = getCheckboxInputData({
  label: 'Frekles',
  name: INPUT_NAME_FREKLES,
  value: false,
} as const);

const WelcomeToTheWorldInputsHairColorOptions = [
  getRadioColorInputOptionData({
    color: '#F8D992',
    value: INPUT_VALUE_HAIR_COLOR_BLONDE,
  }),
  getRadioColorInputOptionData({
    color: '#CF744B',
    value: INPUT_VALUE_HAIR_COLOR_RED,
  }),
  getRadioColorInputOptionData({
    color: '#9F6D48',
    value: INPUT_VALUE_HAIR_COLOR_BROWN,
  }),
  getRadioColorInputOptionData({
    color: '#4D423B',
    value: INPUT_VALUE_HAIR_COLOR_BLACK,
  }),
];

export const WelcomeToTheWorldInputsHairColor = getRadioColorInputData({
  label: 'Hair color',
  options: WelcomeToTheWorldInputsHairColorOptions,
  value: INPUT_VALUE_HAIR_COLOR_BLONDE,
  name: INPUT_NAME_HAIR_COLOR,
});

export const WelcomeToTheWorldInputsHairStyle = getRadioInputData({
  label: 'Hair style',
  options: [
    getRadioInputOptionData({
      label: 'Straight',
      imgSrc: 'assets/images/wttw-canvas/form-icons/straight.png',
      value: INPUT_VALUE_HAIR_STYLE_STRAIGHT,
    }),
    getRadioInputOptionData({
      label: 'Curl',
      imgSrc: 'assets/images/wttw-canvas/form-icons/curl.png',
      value: INPUT_VALUE_HAIR_STYLE_CURL,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_STRAIGHT,
  name: INPUT_NAME_HAIR_STYLE,
});

export const WelcomeToTheWorldInputsClothColor = getRadioColorInputData({
  label: 'Cloth color',
  options: [
    getRadioColorInputOptionData({
      color: '#7ED0DA',
      value: INPUT_VALUE_CLOTH_COLOR_BLUE,
    }),
    getRadioColorInputOptionData({
      color: '#FBD269',
      value: INPUT_VALUE_CLOTH_COLOR_YELLOW,
    }),
    getRadioColorInputOptionData({
      color: '#F3A484',
      value: INPUT_VALUE_CLOTH_COLOR_RED,
    }),
    getRadioColorInputOptionData({
      color: '#C3CD59',
      value: INPUT_VALUE_CLOTH_COLOR_GREEN,
    }),
  ],
  value: INPUT_VALUE_CLOTH_COLOR_BLUE,
  name: INPUT_NAME_CLOTH_COLOR,
});

export const WelcomeToTheWorldInputsLanguage = getSelectInputData({
  label: 'Language',
  placeholder: '',
  options: languageArr.map((lang) =>
    getSelectInputOptionData({ label: lang, value: lang }),
  ),
  value: INPUT_VALUE_JAPANESE,
  name: INPUT_NAME_LANGUAGE,
} as const);

// * canvas common
const WelcomeToTheWorldInputsCanvasCommon = {
  width: 261,
  height: 444,
  // crop: {
  //   top: 15,
  //   right: 20,
  //   bottom: 18,
  //   left: 23,
  // },
  cropLtMd: {
    // top: 15,
    // left: 76,
    bottom: 135,
  },
  name: INPUT_NAME_RESERVED_CANVAS1,
} as const;

const WelcomeToTheWorldInputsCanvasInputs = [
  WelcomeToTheWorldInputsSkinColor,
  WelcomeToTheWorldInputsFrekles,
  WelcomeToTheWorldInputsHairColor,
  WelcomeToTheWorldInputsHairStyle,
  WelcomeToTheWorldInputsClothColor,
];

const WelcomeToTheWorldInputsCanvasItemsSkin: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S01.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === false,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S05.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === true,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S02.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === false,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S06.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === true,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S03.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === false,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S07.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === true,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S04.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === false,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/S/website-S08.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsFrekles,
        condition: (v: boolean) => v === true,
      },
    ],
  },
];

const WelcomeToTheWorldInputsCanvasItemsCloth: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/wttw-canvas/C/website-C01.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_BLUE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/C/website-C02.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_YELLOW,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/C/website-C03.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_RED,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/C/website-C04.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_GREEN,
      },
    ],
  },
];

const WelcomeToTheWorldInputsCanvasItemsHair: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H01.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_STRAIGHT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H05.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_CURL,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H02.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_STRAIGHT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H06.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_CURL,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H03.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_STRAIGHT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H07.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_CURL,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H04.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_STRAIGHT,
      },
    ],
  },
  {
    imgSrc: 'assets/images/wttw-canvas/H/website-H08.png',
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: WelcomeToTheWorldInputsHairStyle,
        condition: (v: THairStyle) => v === INPUT_VALUE_HAIR_STYLE_CURL,
      },
    ],
  },
];

export const WelcomeToTheWorldInputsCanvas = getCanvasInputData({
  ...WelcomeToTheWorldInputsCanvasCommon,
  label: 'book3.input.canvas.title',
  inputs: WelcomeToTheWorldInputsCanvasInputs,
  items: [
    ...WelcomeToTheWorldInputsCanvasItemsSkin,
    ...WelcomeToTheWorldInputsCanvasItemsCloth,
    ...WelcomeToTheWorldInputsCanvasItemsHair,
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsCanvasInputs),
});

// * non related to initial book-form
export const WelcomeToTheWorldInputsCoverImage = getRadioCoverInputData({
  options: [
    getRadioCoverInputOptionData({
      label: 'ピクニック',
      value: 'A',
      imgSrc: 'assets/images/wttw-covers/A.png',
    }),
    getRadioCoverInputOptionData({
      label: 'ドリーミー',
      value: 'B',
      imgSrc: 'assets/images/wttw-covers/B.png',
    }),
  ],
  // value: 'A',
  name: INPUT_NAME_COVER_IMAGE,
});

// * Season
export const WelcomeToTheWorldInputsSeason = getRadioInputData({
  label: '',
  placeholder: '',
  options: [
    getRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
      imgSrc: 'assets/images/season-step/b2_spring.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
    }),
    getRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
      imgSrc: 'assets/images/season-step/b2_summer.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
    }),
    getRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
      imgSrc: 'assets/images/season-step/b2_autumn.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
    }),
    getRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
      imgSrc: 'assets/images/season-step/b2_winter.png',
      imgExpandTopPx: 21,
      imgExpandRightPx: 35,
      imgExpandBottomPx: 5,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
    }),
  ],
  // value: '',
  name: INPUT_NAME_SEASON,
});

// * Parents
const WelcomeToTheWorldInputsParentsCanvasCommon = {
  width: 400,
  height: 348,
  noLtMdBackground: true,
  borderRadius: '10px',
  // crop: {
  //   top: 15,
  //   right: 20,
  //   bottom: 18,
  //   left: 23,
  // },
  // cropLtMd: {
  //   // top: 15,
  //   // left: 76,
  //   bottom: 135,
  // },
  // name: INPUT_NAME_RESERVED_CANVAS1,
} as const;

export const WelcomeToTheWorldInputsP1SkinColor = getRadioColorInputData({
  label: 'Skin color',
  options: WelcomeToTheWorldInputsSkinColorOptions,
  value: INPUT_VALUE_SKIN_COLOR_WHITE,
  name: INPUT_NAME_P1_SKIN_COLOR,
});

export const WelcomeToTheWorldInputsP2SkinColor = getRadioColorInputData({
  label: 'Skin color',
  options: WelcomeToTheWorldInputsSkinColorOptions,
  value: INPUT_VALUE_SKIN_COLOR_WHITE,
  name: INPUT_NAME_P2_SKIN_COLOR,
});

export const WelcomeToTheWorldInputsP1HairColor = getRadioColorInputData({
  label: 'Hair color',
  options: WelcomeToTheWorldInputsHairColorOptions,
  value: INPUT_VALUE_HAIR_COLOR_BLONDE,
  name: INPUT_NAME_P1_HAIR_COLOR,
});

export const WelcomeToTheWorldInputsP2HairColor = getRadioColorInputData({
  label: 'Hair color',
  options: WelcomeToTheWorldInputsHairColorOptions,
  value: INPUT_VALUE_HAIR_COLOR_BLONDE,
  name: INPUT_NAME_P2_HAIR_COLOR,
});

const WelcomeToTheWorldInputsParentsCanvas1Inputs = [
  WelcomeToTheWorldInputsP1SkinColor,
  WelcomeToTheWorldInputsP1HairColor,
];

const WelcomeToTheWorldInputsParentsCanvas2Inputs = [
  WelcomeToTheWorldInputsP2SkinColor,
  WelcomeToTheWorldInputsP2HairColor,
];

const getParentsCanvasItemsHair = (
  number: number,
  inputToCheck:
    | typeof WelcomeToTheWorldInputsP1HairColor
    | typeof WelcomeToTheWorldInputsP2HairColor,
): ICanvasInputItem[] => [
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}H/P${number}H-01.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
    ],
  },
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}H/P${number}H-02.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
    ],
  },
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}H/P${number}H-03.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
    ],
  },
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}H/P${number}H-04.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
    ],
  },
];

const getParentsCanvasItemsSkin = (
  number: number,
  inputToCheck:
    | typeof WelcomeToTheWorldInputsP1SkinColor
    | typeof WelcomeToTheWorldInputsP2SkinColor,
): ICanvasInputItem[] => [
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}S/P${number}S-01.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
    ],
  },
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}S/P${number}S-02.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
    ],
  },
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}S/P${number}S-03.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
    ],
  },
  {
    imgSrc: `assets/images/wttw-canvas/parents/P${number}S/P${number}S-04.png`,
    showWhen: [
      {
        inputToCheck,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
    ],
  },
];

export const WelcomeToTheWorldInputsParentsCanvasP1 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas1Inputs,
  items: [
    ...getParentsCanvasItemsSkin(1, WelcomeToTheWorldInputsP1SkinColor),
    ...getParentsCanvasItemsHair(1, WelcomeToTheWorldInputsP1HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas1Inputs),
  name: INPUT_NAME_RESERVED_CANVAS1,
});

export const WelcomeToTheWorldInputsParentsCanvasP2 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas2Inputs,
  items: [
    ...getParentsCanvasItemsSkin(2, WelcomeToTheWorldInputsP2SkinColor),
    ...getParentsCanvasItemsHair(2, WelcomeToTheWorldInputsP2HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas2Inputs),
  name: INPUT_NAME_RESERVED_CANVAS2,
});

export const WelcomeToTheWorldInputsParentsCanvasP3 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas1Inputs,
  items: [
    ...getParentsCanvasItemsSkin(3, WelcomeToTheWorldInputsP1SkinColor),
    ...getParentsCanvasItemsHair(3, WelcomeToTheWorldInputsP1HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas1Inputs),
  name: INPUT_NAME_RESERVED_CANVAS1,
});

export const WelcomeToTheWorldInputsParentsCanvasP4 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas2Inputs,
  items: [
    ...getParentsCanvasItemsSkin(4, WelcomeToTheWorldInputsP2SkinColor),
    ...getParentsCanvasItemsHair(4, WelcomeToTheWorldInputsP2HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas2Inputs),
  name: INPUT_NAME_RESERVED_CANVAS2,
});

export const WelcomeToTheWorldInputsParentsCanvasP5 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas1Inputs,
  items: [
    ...getParentsCanvasItemsSkin(5, WelcomeToTheWorldInputsP1SkinColor),
    ...getParentsCanvasItemsHair(5, WelcomeToTheWorldInputsP1HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas1Inputs),
  name: INPUT_NAME_RESERVED_CANVAS1,
});

export const WelcomeToTheWorldInputsParentsCanvasP6 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas2Inputs,
  items: [
    ...getParentsCanvasItemsSkin(6, WelcomeToTheWorldInputsP2SkinColor),
    ...getParentsCanvasItemsHair(6, WelcomeToTheWorldInputsP2HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas2Inputs),
  name: INPUT_NAME_RESERVED_CANVAS2,
});

export const WelcomeToTheWorldInputsParentsCanvasP7 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas1Inputs,
  items: [
    ...getParentsCanvasItemsSkin(7, WelcomeToTheWorldInputsP1SkinColor),
    ...getParentsCanvasItemsHair(7, WelcomeToTheWorldInputsP1HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas1Inputs),
  name: INPUT_NAME_RESERVED_CANVAS1,
});

export const WelcomeToTheWorldInputsParentsCanvasP8 = getCanvasInputData({
  ...WelcomeToTheWorldInputsParentsCanvasCommon,
  inputs: WelcomeToTheWorldInputsParentsCanvas1Inputs,
  items: [
    ...getParentsCanvasItemsSkin(8, WelcomeToTheWorldInputsP1SkinColor),
    ...getParentsCanvasItemsHair(8, WelcomeToTheWorldInputsP1HairColor),
  ],
  value: bookInputsToNameValueMap(WelcomeToTheWorldInputsParentsCanvas1Inputs),
  name: INPUT_NAME_RESERVED_CANVAS1,
});

export const WelcomeToTheWorldInputsParentsCanvasArr = [
  WelcomeToTheWorldInputsParentsCanvasP1,
  WelcomeToTheWorldInputsParentsCanvasP2,
  WelcomeToTheWorldInputsParentsCanvasP3,
  WelcomeToTheWorldInputsParentsCanvasP4,
  WelcomeToTheWorldInputsParentsCanvasP5,
  WelcomeToTheWorldInputsParentsCanvasP6,
  WelcomeToTheWorldInputsParentsCanvasP7,
  WelcomeToTheWorldInputsParentsCanvasP8,
];

// * mutations
bookInputValidatorWhen(WelcomeToTheWorldInputsKidsName, [
  {
    validator: WelcomeToTheWorldInputsKidsNameValidatorEn,
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsLanguage,
        condition: (language: TLanguage) => language === INPUT_VALUE_ENGLISH,
      },
    ],
  },
  {
    validator: WelcomeToTheWorldInputsKidsNameValidator,
    showWhen: [
      {
        inputToCheck: WelcomeToTheWorldInputsLanguage,
        condition: (language: TLanguage) => language === INPUT_VALUE_JAPANESE,
      },
    ],
  },
]);

// WelcomeToTheWorldInputsCanvas
bookInputShowWhen(
  WelcomeToTheWorldInputsCanvas,
  WelcomeToTheWorldInputsKidsName,
  // value is not passed when invalid
  (value?: string) => !!value,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsCanvas,
  WelcomeToTheWorldInputsKidsBirthday,
  // value is not passed when invalid
  (value?: Date) => !!value,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsCanvas,
  WelcomeToTheWorldInputsParents,
  // value is not passed when invalid
  (value?: string) => !!value,
);

// WelcomeToTheWorldInputsParentsCanvas
bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP1,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_MOM_AND_DAD,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP2,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_MOM_AND_DAD,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP3,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_MOM_AND_MOM,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP4,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_MOM_AND_MOM,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP5,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_DAD_AND_DAD,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP6,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_DAD_AND_DAD,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP7,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_MOM,
);

bookInputShowWhen(
  WelcomeToTheWorldInputsParentsCanvasP8,
  WelcomeToTheWorldInputsParents,
  (value?: TParents) => value === INPUT_VALUE_PARENTS_DAD,
);

const prices = {
  [INPUT_VALUE_COVER_TYPE_SOFT]: getPriceData(BOOK_PRICE_WELCOME_TO_THE_WOLD),
  [INPUT_VALUE_COVER_TYPE_HARD]: getPriceData(
    BOOK_PRICE_WELCOME_TO_THE_WOLD_HARD_COVER,
  ),
} as const;

const coverSoft = getCoverSoft({
  price: prices[INPUT_VALUE_COVER_TYPE_SOFT],
  carousel: [
    'assets/images/covers/bk3/bk3-SC01.jpg',
    'assets/images/covers/bk3/bk3-SC02.jpg',
    'assets/images/covers/bk3/bk3-SC03.jpg',
  ],
});
const coverHard = getCoverHard({
  price: prices[INPUT_VALUE_COVER_TYPE_HARD],
  carousel: [
    'assets/images/covers/bk3/bk3-HC01.jpg',
    'assets/images/covers/bk3/bk3-HC02.jpg',
    'assets/images/covers/bk3/bk3-HC03.jpg',
  ],
});

const WelcomeToTheWorld: IBookPreview = {
  type: 'book',
  caption: 'ようこそ、このせかいへ',
  summary:
    '出産の記念や、1歳になる子どもへ。あなたが生まれたこの世界には…あなたを愛している人がいる。',
  alias: BOOK_ALIAS_WELCOME_TO_THE_WOLD,
  prices: [
    [INPUT_VALUE_COVER_TYPE_SOFT, prices[INPUT_VALUE_COVER_TYPE_SOFT]],
    [INPUT_VALUE_COVER_TYPE_HARD, prices[INPUT_VALUE_COVER_TYPE_HARD]],
  ],
  photos: [
    'assets/images/bk3-carousel01-JP.jpg',
    'assets/images/bk3-carousel02-JP.jpg',
    'assets/images/bk3-carousel03-JP.jpg',
    'assets/images/bk3-carousel04-JP.jpg',
  ],
  menuPhoto: 'assets/images/bk3-sample-blue-JP.png',
  previewPhoto: 'assets/images/books03-JP.png',
  properties: {
    purpose: [PURPOSE_ADVENTURE, PURPOSE_BIRTH_GIFT],
    age: {
      start: 0,
      end: 3,
    },
  },
  notice: {
    caption: 'Book new world',
    description: 'welcome.description',
    points: [
      {
        imgSrc: 'assets/images/welcome-notice-point-1.png',
        caption: 'welcome.notice.point.1',
      },
      {
        imgSrc: 'assets/images/welcome-notice-point-2.png',
        caption: 'welcome.notice.point.2',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタムができるの？',
      description:
        '・主人公の名前をいれる<br>・表紙の色やリボンの色を選べる<br>・お子さんの成長記録（身長・体重）をいれる<br>・写真をいれる（５枚）<br>・ケーキのロウソクの絵柄を選べる<br> ・メッセージをいれる（最大２か所',
    },
    {
      caption: '絵本のストーリーは？',
      description:
        '主人公が着いたところは、どんなところ？たくさんの自然があり、命がある。そして何より、その子のことが大好きな人がいる。',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description:
        '全ての絵本は１冊ずつ、ご注文を受けてからオーダーメイドで印刷・製本されます。マットで高級感のある、環境に配慮した用紙を使用しています。<br><br><b>・全26 ページ<br>・29.7cm x 21cm（本文部分）のA4ヨコ<br>・日本国内で製造</b>',
    },
  ],
  inputs: [
    WelcomeToTheWorldInputsKidsName,
    WelcomeToTheWorldInputsKidsBirthday,
    WelcomeToTheWorldInputsParents,
    WelcomeToTheWorldInputsLanguage,
    WelcomeToTheWorldInputsCanvas,
  ],
  banner: {
    imgSrc: 'assets/images/bk3-banner-desktop-JP.jpg',
    imgSrcLtMd: 'assets/images/bk3-banner-mobile-JP.jpg',
    text: 'まいにちが　だいぼうけん。　ここにある　まほうを　みつけよう。',
    textColor: EBannerTextColor.dark,
  },
  description: [
    {
      imgSrc: 'assets/images/bk3-image01-JP.gif',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: 'いろんな家族の形があるから',
        },
        {
          type: EDescriptionTextItemType.regular,
          text: '主人公のことをここで待っていたのは、ママとパパ？それともパパとパパ？',
        },
        {
          type: EDescriptionTextItemType.regular,
          text: 'どんな形の家族でも、その子を大好きな気持ちは同じ。',
        },
      ],
    },
    {
      imgSrc: 'assets/images/bk3-image02-JP.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: '生まれた時の思い出を、絵本の１ページに',
        },
        {
          type: EDescriptionTextItemType.regular,
          text: '絵本の最後のページには、主人公の写真を追加することができます。',
        },
        {
          type: EDescriptionTextItemType.regular,
          text: 'お名前やお誕生日と一緒に、あの時の思い出を絵本に、ずっと。',
        },
      ],
    },
  ],
  review: {
    text: [
      '「物語のクオリティも高く、家族の思い出としても残しておける品だと思いました。」',
    ],
  },
  reviews: [],
  options: {
    [INPUT_VALUE_COVER_TYPE_HARD]: coverHard,
    [INPUT_VALUE_COVER_TYPE_SOFT]: coverSoft,
  },
  option: INPUT_VALUE_COVER_TYPE_SOFT,
  // TODO
  attributes: [
    {
      id: 'category',
      value: 'books',
    },
  ],
  popularity: 15,
  createdAt: new Date('2020-01-03'),
};

export default WelcomeToTheWorld;
